module.exports = __webpack_public_path__ + "img/roll3.a4a33157.png";